import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function BalanceBoldTypography({ children, text, ...props }) {
  const { t } = useTranslation();

  return (
    <Typography fontWeight={700} fontSize={16} component={'span'} {...props}>
      {children || t(text)}
    </Typography>
  );
}
